import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class DutiesAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      name: null,
      abbreviation: null,
      anac_code: null,
      role: null,
      instructor: false,
      copilot_as_captain: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    this.setState({instructor: false, copilot_as_captain: false});
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      abbreviation: this.state.abbreviation,
      anac_code: this.state.anac_code,
      role: this.state.role,
      instructor: this.state.instructor,
      copilot_as_captain: this.state.copilot_as_captain,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcao/bordo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/funcao/bordo/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.titulo}</h3>
      <Link to="/funcoes/bordo" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.formulario.Nome}</label>
              <input type="text" name="name" className="form-control" placeholder="" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.formulario.Abreviacao}:</label>
              <input type="text" name="abbreviation" className="form-control" placeholder="" value={this.state.abbreviation} onChange={this.handleChange.bind(this, 'abbreviation')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.formulario.CodigoANAC}:</label>
              <Select
                className="form-field-name"
                name="anac_code"
                value={this.state.anac_code}
                searchable={true}
                placeholder={this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.formulario.placeholder.SelecioneCodigoANAC}
                onChange={this.handleSelectChange.bind(this, 'anac_code')}
                options={[
                  {value: "P", label: "P"},
                  {value: "I", label: "I"},
                  {value: "O", label: "O"},
                  {value: "C", label: "C"},
                  {value: "M", label: "M"},
                  {value: "X", label: "X"},
                  {value: "D", label: "D"},
                ]}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.formulario.Funcao}:</label>
              <Select
                className="form-field-name"
                name="role"
                value={this.state.role}
                searchable={true}
                placeholder={this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.formulario.placeholder.SelecioneFuncao}
                onChange={this.handleSelectChange.bind(this, 'role')}
                options={[
                  {value: "captain", label: this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.formulario.opcoesFuncao.CMDT},
                  {value: "copilot", label: this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.formulario.opcoesFuncao.COPIL},
                  {value: "flight_attendant", label: this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.formulario.opcoesFuncao.CMS},
                ]}
              />
            </div>
          </div>
        </div>
          {
            (this.state.role === 'captain') ?
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>{this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.formulario.Instrutor}:</label>
                    <br/>
                    <Toggle
                      checked={this.state.instructor}
                      aria-label=''
                      name="instructor"
                      onChange={this.handleToggleChange.bind(this, 'instructor')} />
                  </div>
                </div>
                <div className="col-md-9">
                  <div className="form-group">
                    <label>{this.locale.FuncoesDeBordo.AdicionarFuncaoDeBordo.formulario.PermiteCopilotoRealizarHorasEmComandoDesdePossuaOsRequisitos}?</label>
                    <br/>
                    <Toggle
                      checked={this.state.copilot_as_captain}
                      aria-label=''
                      name="copilot_as_captain"
                      onChange={this.handleToggleChange.bind(this, 'copilot_as_captain')} />
                  </div>
                </div>
              </div>
                : ''
          }
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.adicionar}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default DutiesAdd;



// WEBPACK FOOTER //
// ./src/Components/Duties/DutiesAdd.js